import { _showModalBs5, _hideModalBs5, } from "../../../output/Specular.Bootstrap.Modal/foreign.js";
export const showModalBs5 = _showModalBs5;
export const hideModalBs5 = _hideModalBs5;
